<template>
  <b-modal
    :visible="visible"
    :title="isEdit ? 'تعديل خدمة' : 'أنشئ خدمة'"
    size="lg"
    @hidden="handleClose"
    @ok="handleSubmit"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- Name -->
        <b-col cols="12">
          <b-form-group
            label="اسم الخدمة *"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="form.name"
              placeholder="أدخل اسم الخدمة"
              :state="errors.name ? false : null"
            />
            <b-form-invalid-feedback v-if="errors.name">
              {{ errors.name[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Service Type -->
        <!-- <b-col cols="12" md="6">
          <b-form-group label="نوع الخدمة *" label-for="service-type">
            <v-select
              v-model="form.service_type_id"
              :options="serviceTypeOptions"
              :reduce="option => option.value"
              label="label"
              placeholder="اختر نوع الخدمة"
              :state="errors.service_type_id ? false : null"
            />
            <b-form-invalid-feedback v-if="errors.service_type_id" :state="false">
              {{ errors.service_type_id[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col> -->

        <!-- Priority -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="الأولوية"
            label-for="priority"
          >
            <v-select
              v-model="form.priority"
              :options="priorityOptions"
              :reduce="option => option.value"
              label="label"
              placeholder="اختر الأولوية (اختياري)"
              :state="errors.priority ? false : null"
            />
            <b-form-invalid-feedback
              v-if="errors.priority"
              :state="false"
            >
              {{ errors.priority[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Description -->
        <b-col cols="12">
          <b-form-group
            label="الوصف"
            label-for="description"
          >
            <b-form-textarea
              id="description"
              v-model="form.description"
              placeholder="أدخل الوصف"
              rows="3"
              :state="errors.description ? false : null"
            />
            <b-form-invalid-feedback v-if="errors.description">
              {{ errors.description[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Parent Service -->
        <b-col cols="12">
          <b-form-group
            label="الخدمة الأب"
            label-for="parent-service"
          >
            <v-select
              v-model="form.parent_service_id"
              :options="parentServiceOptions"
              :reduce="option => option.value"
              label="label"
              placeholder="اختر الخدمة الاب (اختياري)"
              :state="errors.parent_service_id ? false : null"
            />
            <b-form-invalid-feedback
              v-if="errors.parent_service_id"
              :state="false"
            >
              {{ errors.parent_service_id[0] }}
            </b-form-invalid-feedback>
            <small class="text-muted">اترك فارغ للخدمة الاب</small>
          </b-form-group>
        </b-col>

        <!-- Order -->
        <b-col
          v-if="isEdit || form.parent_service_id"
          cols="12"
        >
          <b-form-group
            label="اولوية"
            label-for="order"
          >
            <b-form-input
              id="order"
              v-model.number="form.order"
              type="number"
              placeholder="الاولوية"
              :state="errors.order ? false : null"
            />
            <b-form-invalid-feedback v-if="errors.order">
              {{ errors.order[0] }}
            </b-form-invalid-feedback>
            <small class="text-muted">Lower numbers appear first</small>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="outline-secondary"
        @click="cancel()"
      >
        إلغاء
      </b-button>
      <b-button
        variant="primary"
        :disabled="loading"
        @click="ok()"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="SaveIcon"
          class="mr-50"
        />
        <span class="align-middle">{{ isEdit ? 'تعديل' : 'أنشئ' }}</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ServiceFormModal',
  components: {
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    BSpinner,
    vSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    service: {
      type: Object,
      default: null,
    },
    parentServiceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        // service_type_id: null,
        parent_service_id: null,
        priority: null,
        order: null,
      },
      errors: {},
      loading: false,
      serviceTypeOptions: [],
      parentServiceOptions: [],
      priorityOptions: [
        { label: '1 - Low', value: 1 },
        { label: '2', value: 2 },
        { label: '3 - Medium', value: 3 },
        { label: '4', value: 4 },
        { label: '5 - High', value: 5 },
      ],
    }
  },
  computed: {
    isEdit() {
      return !!this.service
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadOptions()
        this.initForm()
      }
    },
  },
  methods: {
    ...mapActions('services', [
      'createService',
      'updateService',
      'fetchServices',
    ]),
    ...mapActions('serviceTypes', ['fetchActiveServiceTypes']),
    async loadOptions() {
      try {
        // Load service types
        const serviceTypesResponse = await this.fetchActiveServiceTypes()
        this.serviceTypeOptions = serviceTypesResponse.data.map(st => ({
          label: st.name,
          value: st.id,
        }))

        // Load services for parent selection
        const servicesResponse = await this.fetchServices({ all: true })
        this.parentServiceOptions = servicesResponse.data
          .filter(s => !this.service || s.id !== this.service.id) // Exclude current service
          .map(s => ({
            label: s.name,
            value: s.id,
          }))
      } catch (error) {
        console.error('Failed to load options:', error)
      }
    },
    initForm() {
      if (this.isEdit) {
        this.form = {
          name: this.service.name,
          description: this.service.description,
          // service_type_id: this.service.service_type_id,
          parent_service_id: this.service.parent_service_id,
          priority: this.service.priority,
          order: this.service.order,
        }
      } else {
        this.form = {
          name: '',
          description: '',
          // service_type_id: null,
          parent_service_id: this.parentServiceId,
          priority: null,
          order: null,
        }
      }
      this.errors = {}
    },
    async handleSubmit(bvModalEvt) {
      if (bvModalEvt) {
        bvModalEvt.preventDefault()
      }

      try {
        this.loading = true
        this.errors = {}

        if (this.isEdit) {
          await this.updateService({
            id: this.service.id,
            data: this.form,
          })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Service updated successfully',
            },
          })
        } else {
          await this.createService(this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Service created successfully',
            },
          })
        }

        this.$emit('saved')
        this.handleClose()
      } catch (error) {
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {}
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response?.data?.message || 'Failed to save service',
          },
        })
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.$emit('close')
      this.form = {
        name: '',
        description: '',
        // service_type_id: null,
        parent_service_id: null,
        priority: null,
        order: null,
      }
      this.errors = {}
    },
  },
}
</script>
